import { call, put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_EMAIL_DOMAIN,
    SYSTEM_CREATE_EMAIL_DOMAIN,
    SYSTEM_DELETE_EMAIL_DOMAIN,
    SYSTEM_EDIT_EMAIL_DOMAIN,
    GET_EMAIL_DOMAIN_LIST,
    UPDATE_EMAIL_DOMAIN,
} from 'store/key';
import { produce } from 'utility/general';
import api from 'api/call';

const initialState = {
    emailDomainList: [],
};

function* getEmailDomains(action) {
    try {
        yield put({
            type: SET_EMAIL_DOMAIN,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.authorizedEmail.getAuthorizedDomain, null);
        const { result } = res.data;
        yield put({
            type: SET_EMAIL_DOMAIN,
            payload: {
                emailDomainList: result.data,
            },
        });
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }

    yield put({
        type: SET_EMAIL_DOMAIN,
        payload: {
            isLoading: false,
        },
    });
}

function* createEmailDomain(action) {
    console.log('reducer,create email domail...');
    const { row, callback } = action.payload;
    try {
        yield call(api.authorizedEmail.createAuthorizedDomain, row);
        callback?.();
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
}

function* updateEmailDomain(action) {
    const { row, callback } = action.payload;
    try {
        yield call(api.authorizedEmail.updateAuthorizedDomain, row);
        callback?.();
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
}

function* editEmailDomain(action) {
    const row = action.payload;
    const { emailDomain: state } = yield select();
    let list = state.emailDomainList;
    const index = list.findIndex((i) => i.id === row.id);
    state.emailDomainList[index] = { ...row };
    yield put({
        type: SET_EMAIL_DOMAIN,
        payload: state,
    });
}

function* deleteEmailDomain(action) {
    const { id, callback } = action.payload;
    try {
        yield call(api.authorizedEmail.deleteAuthorizedDomain, id);
        callback?.();
    } catch (error) {
        console.log('emailDomain reducer.js error', error);
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EMAIL_DOMAIN:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchEmailDomain() {
    yield takeEvery(SYSTEM_CREATE_EMAIL_DOMAIN, safeSaga(createEmailDomain));
    yield takeEvery(SYSTEM_EDIT_EMAIL_DOMAIN, safeSaga(editEmailDomain));
    yield takeEvery(SYSTEM_DELETE_EMAIL_DOMAIN, safeSaga(deleteEmailDomain));
    yield takeEvery(GET_EMAIL_DOMAIN_LIST, safeSaga(getEmailDomains));
    yield takeEvery(UPDATE_EMAIL_DOMAIN, safeSaga(updateEmailDomain));
}

export default reducer;
